import { render } from "./RedditPoll.vue?vue&type=template&id=d0ff78e4"
import script from "./RedditPoll.vue?vue&type=script&lang=js"
export * from "./RedditPoll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__